import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, TableBody, TableHead, IconButton, Tooltip } from '@mui/material';
import { StyledTable, StyledTableRow, StyledHeaderCell, StyledTableBodyCell, StyledActionHeaderCell } from 'components/common/Styles';
import { Card } from '@totalsoft/rocket-ui';
import { Toc as TocIcon, Check, Close, Edit, Delete } from '@mui/icons-material';
import { Button } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_ITEMS_WRITE } from 'constants/rightsCodes';

const ItemPropertiesComponent = ({ data, loading, onDelete, onEdit, onAddNew }) => {
  const [t] = useTranslation();
  const canWrite = usePermission(ADMIN_ITEMS_WRITE);

  return (
    <Card icon={TocIcon} iconColor='primary' title={t('Items.Properties.Title')}>
      <Grid container spacing={1} id='parameterList'>
        <StyledTable>
          <TableHead>
            <StyledTableRow>
              <StyledHeaderCell style={{ textAlign: 'start', width: '10%' }}>{t('Items.Properties.Code')}</StyledHeaderCell>
              <StyledHeaderCell style={{ textAlign: 'start', width: '20%' }}>{t('Items.Properties.Name')}</StyledHeaderCell>
              <StyledHeaderCell style={{ textAlign: 'center', width: '15%' }}>{t('Items.Properties.Mandatory')}</StyledHeaderCell>
              <StyledHeaderCell style={{ textAlign: 'start', width: '25%' }}>{t('Items.Properties.DefaultValue')}</StyledHeaderCell>
              <StyledHeaderCell style={{ textAlign: 'start', width: '20%' }}>{t('Items.Properties.Comments')}</StyledHeaderCell>
              <StyledActionHeaderCell align='right'>
                <Button itemId='Items_AddProperties' color='primary' onClick={onAddNew} disabled={!canWrite}>
                  {`+ ${t('Add')}`}
                </Button>
              </StyledActionHeaderCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {!loading &&
              data &&
              data.map(property => {
                return (
                  <StyledTableRow hover key={property.propertyId}>
                    <StyledTableBodyCell style={{ textAlign: 'start', width: '10%' }}>{property.propertyCode} </StyledTableBodyCell>
                    <StyledTableBodyCell style={{ textAlign: 'start', width: '20%' }}>{property.propertyName}</StyledTableBodyCell>
                    <StyledTableBodyCell style={{ textAlign: 'center', width: '15%' }}>
                      {property.mandatory ? <Check /> : <Close />}
                    </StyledTableBodyCell>
                    <StyledTableBodyCell style={{ textAlign: 'start', width: '25%' }}>{property.defaultValue || '-'}</StyledTableBodyCell>
                    <StyledTableBodyCell style={{ textAlign: 'start', width: '20%' }}>{property.comments || '-'}</StyledTableBodyCell>
                    <StyledTableBodyCell>
                      <Box display='flex' gap={1} alignItems='center' justifyContent='end'>
                        <Tooltip title={t('Items.Edit')}>
                          <IconButton disabled={!canWrite} color='primary' size='small' onClick={() => onEdit(property)}>
                            <Edit fontSize='small' />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t('Items.Delete')}>
                          <IconButton disabled={!canWrite} color='primary' size='small' onClick={() => onDelete(property.propertyId)}>
                            <Delete fontSize='small' />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </StyledTableBodyCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </StyledTable>
      </Grid>
    </Card>
  );
};

ItemPropertiesComponent.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  onAddNew: PropTypes.func
};

export default ItemPropertiesComponent;
